(function(){
  var BTN_TEXT = 'ajouter le duo au panier — 30,80 €';

  function normalize(s){
    return s.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function tryOpenCartDrawer(){
    try {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return true;
      }
    } catch(e){}
    return false;
  }

  function addRoutinePack(btn){
    if(btn.dataset.clRoutineLoading === '1') return;
    var original = btn.textContent;
    btn.dataset.clRoutineLoading = '1';
    btn.textContent = 'Ajout en cours...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({
        items: [
          {id: 54551146103122, quantity: 1},
          {id: 54551096820050, quantity: 1}
        ]
      })
    })
    .then(function(r){
      if(!r.ok){ return r.json().then(function(err){ throw new Error(err.description || 'add failed'); }); }
      return r.json();
    })
    .then(function(){
      btn.dataset.clRoutineLoading = '0';
      btn.textContent = original;
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
      var opened = tryOpenCartDrawer();
      if(!opened){
        window.location.href = '/cart';
      }
    })
    .catch(function(){
      btn.dataset.clRoutineLoading = '0';
      btn.textContent = original;
      alert("Impossible d'ajouter le pack au panier, reessaie.");
    });
  }

  document.addEventListener('click', function(e){
    var link = e.target.closest('a, button');
    if(!link) return;
    var text = normalize(link.textContent);
    if(text === BTN_TEXT || link.classList.contains('cl-routine-pack-btn')){
      e.preventDefault();
      e.stopPropagation();
      addRoutinePack(link);
    }
  }, true);
})();
